import { replaceHistory } from "./utils";

const LISTING_SEARCH_CONTEXT_KEY = "LISTING_SEARCH_CONTEXT";

const LISTING_CONTEXT_PARAMS = [
  "countries",
  "startDate",
  "endDate",
  "travellers",
  "tripOption",
  "planType",
] as const;

/**
 * Snapshot the current listing URL search params into sessionStorage
 * so common-landing can restore them on browser-back navigation.
 */
export const persistListingContext = () => {
  if (typeof window === "undefined") return;
  try {
    const params = new URLSearchParams(window.location.search);
    const context: Record<string, string> = {};
    for (const key of LISTING_CONTEXT_PARAMS) {
      const val = params.get(key);
      if (val) context[key] = val;
    }
    if (Object.keys(context).length > 0) {
      sessionStorage.setItem(
        LISTING_SEARCH_CONTEXT_KEY,
        JSON.stringify(context)
      );
    }
  } catch {
    // fail silently — storage may be unavailable
  }
};

/**
 * If a stored listing context exists, push its values into the current
 * URL via replaceHistory (synchronous) and remove the entry.
 * Must be called during the render body of a parent component so that
 * children read the updated window.location.search.
 */
export const applyAndClearListingContext = () => {
  if (typeof window === "undefined") return;
  try {
    const stored = sessionStorage.getItem(LISTING_SEARCH_CONTEXT_KEY);
    if (!stored) return;
    const context: Record<string, string> = JSON.parse(stored);
    for (const [key, value] of Object.entries(context)) {
      if (value) replaceHistory(key, value);
    }
    sessionStorage.removeItem(LISTING_SEARCH_CONTEXT_KEY);
  } catch {
    // fail silently — corrupted data or storage unavailable
  }
};
